import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TwoFactorAuthenticationService } from '../../service/two-factor-authentication.service';

@Component({
  selector: 'app-already-activated',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './already-activated.component.html',
  styleUrls: ['./already-activated.component.scss'],
})
export class AlreadyActivatedComponent {
  submitting: boolean = false; 

  constructor(
    public ref: DynamicDialogRef,
    private twoFactorService: TwoFactorAuthenticationService
  ) {}

  onCancel(): void {
    this.ref.close(false);
  }

  onNext(): void {
    if (this.submitting) return;
    this.submitting = true;

    this.ref.close(true);
    this.twoFactorService.openReAuthenticationDialog('unenroll');
    this.submitting = false;
  }
}